import React from 'react';
import './teacher-portal-bottom-menu.css'
import { CalendarDaysIcon, CalendarIcon, ClockIcon, UserIcon } from '@heroicons/react/20/solid';
import { UsersIcon } from '@heroicons/react/24/outline';
import CalendarAtharoIcon from './icons/CalendarAtharoIcon';
import TimesheetsAtharoIcon from './icons/TimesheetsAtharoIcon';
import AvailabilityAtharoIcon from './icons/AvailabilityAtharoIcon';
import ProfileAtharoIcon from './icons/ProfileAtharoIcon';
const TeacherPortalBottomMenu = ({bottomMenuView, setBottomMenuView, userData}) => {
    return (
        <div className="teacher-portal-bottom-menu">
            {userData.School === 'psma' && 
            <div className="teacher-portal-bottom-menu__item">
                <div className='teacher-portal-bottom-menu__item__icon' style={bottomMenuView === 'calendar' ? {backgroundColor: "#fff"} : {backgroundColor: "#ffffff15"}} onClick={() => setBottomMenuView('calendar')}>
                    <CalendarAtharoIcon myFill={bottomMenuView === 'calendar' ? "#2A3944"  : "#fff"} />
                </div>
                <div className='teacher-portal-bottom-menu__item__name'>CALENDAR</div>
            </div>}
            <div className="teacher-portal-bottom-menu__item">
                <div className='teacher-portal-bottom-menu__item__icon' style={bottomMenuView === 'timesheets' ? {backgroundColor: "#fff"} : {backgroundColor: "#ffffff15"}} onClick={() => setBottomMenuView('timesheets')}>
                    <TimesheetsAtharoIcon myFill={bottomMenuView === 'timesheets' ? "#2A3944"  : "#fff"} />
                </div>
                <div className='teacher-portal-bottom-menu__item__name'>TIMESHEETS</div>
            </div>
            <div className="teacher-portal-bottom-menu__item">
                <div className='teacher-portal-bottom-menu__item__icon' style={bottomMenuView === 'availability' ? {backgroundColor: "#fff"} : {backgroundColor: "#ffffff15"}} onClick={() => setBottomMenuView('availability')}>
                    <AvailabilityAtharoIcon myFill={bottomMenuView === 'availability' ? "#2A3944"  : "#fff"} />
                </div>
                <div className='teacher-portal-bottom-menu__item__name'>AVAILABILITY</div>
            </div>
            <div className="teacher-portal-bottom-menu__item">
                <div className='teacher-portal-bottom-menu__item__icon' style={bottomMenuView === 'profile' ? {backgroundColor: "#fff"} : {backgroundColor: "#ffffff15"}} onClick={() => setBottomMenuView('profile')}>
                    <ProfileAtharoIcon myFill={bottomMenuView === 'profile' ? "#2A3944"  : "#fff"} />
                </div>
                <div className='teacher-portal-bottom-menu__item__name'>PROFILE</div>
            </div>
        </div>
    )
}
export default TeacherPortalBottomMenu;